document.addEventListener("DOMContentLoaded", () => {
  init();
});

function init() {
  setTimeout(function() {
    handleProductPageViews();
  }, 1000);
}

function handleProductPageViews() {
  const viewCount = document.querySelector('[js-product="viewCount"]');

  if (!viewCount) {
    return;
  }

  viewCount.innerHTML = 10 + Math.floor(Math.random() * 5);
  cycleViewCount(viewCount);
}

function cycleViewCount(viewCount) {
  setTimeout(function() {
    cycleViewCount(viewCount);
    viewCount.innerHTML = 10 + Math.floor(Math.random() * 5);
  }, 1500 + Math.floor(Math.random() * 60000));
}

$("#size-guide-modal .close").click(function(){
  $("#size-guide-modal").hide();
});

$(document).ready(function(){
  if($(window).width() < 1025){
    $("#top-language-currency").appendTo("#top-language-currency__mobile");
  }
  if($(window).width() < 768){
    $(".header-items .header-language_currency").appendTo("#header-language_currency-mobile");

    setTimeout(function(){
    // $('.transcy-switcher-manual').appendTo('.transcy-switcher__mobile');
    }, 1000);
  }
});
$(window).resize(function(){
  if($(window).width() < 1025){
    $("#top-language-currency").appendTo("#top-language-currency__mobile");
  }
  if($(window).width() < 768){
    $(".header-items .header-language_currency").appendTo("#header-language_currency-mobile");
  }
});

$('.sidebarBlock-headingWrapper .sidebarBlock-heading').click(function(){
  if($(this).parents(".sidebarBlock").hasClass('open')){
    $(this).parents(".sidebarBlock").removeClass('open');
  }else{
    $(this).parents(".sidebarBlock").addClass('open');
  }
});

$(".sidebarBlock-contentWrapper .sidebarBlock-heading").click(function(){
  $(this).parents(".sidebarBlock-contentWrapper").hide();
});

$(".halo-sidebar-close").click(function(){
  $(".sidebarBlock-contentWrapper").hide();
});

$(".wrapper-item-size__button").click(function(){
  $(this).parent().toggleClass("show");
});

$('.card-product__slider').slick({
  dots: false,
  arrows: true,
  infinite: false,
  speed: 100,
  slidesToShow: 1,
  slidesToScroll: 1,
  nextArrow: '<div class="arrow-right"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></div>',
  prevArrow: '<div class="arrow-left"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></div>'
});
$('.toolbar .toolbar-viewAs .toolbar-icon').click(function(){
  $('.card-product__slide').css('opacity', '0');
  $('.card-product__slider').slick('slickGoTo', 0);
  setTimeout(function(){
    $('.card-product__slide').css('opacity', '1');
  }, 100);
});
$('.card-product__slider').on('click', function (e) {
  var container = $(".card-product__slider .slick-arrow");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $(this).parents('.card').find('.card-title').get(0).click();
  }
});

$('.trustpilot-review__slider').slick({
  dots: false,
  arrows: true,
  infinite: false,
  slidesToShow: 5,
  slidesToScroll: 1,
  nextArrow: '<div class="arrow-right"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></div>',
  prevArrow: '<div class="arrow-left"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></div>',
  responsive: [
    {
      breakpoint: 1201,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 551,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$('.halo-currency .currency-menu .dropdown-item').click(function(){
  $.session.remove("country_name");
  var country_name = $(this).data('country');
  $.session.set("country_name", country_name);
});

$(function(){
  // if(typeof($.session.get("country_name")) === 'undefined'){
  //   $('.header-language_currency .dropdown-item[data-country="United Kingdom"]').get('0').click();
  // }else{
  //   $('.header-language_currency .halo-top-currency .dropdown-toggle .text span').text($.session.get("country_name"));
  // }

  $('.previewCartShippingReturn-title').click(function(){
    $(this).parent().toggleClass('open');
    $(this).parent().find('.previewCartShippingReturn-content').slideToggle();
  });

  $('.klaviyo-flyout svg').click(function(){
    $(this).parent().addClass('hidden');
    $.session.set("klaviyo-form", "closed");
  });
  if($.session.get('klaviyo-form') == 'closed'){
    $('.klaviyo-flyout').addClass('hidden');
  }else{
    $('.klaviyo-flyout').removeClass('hidden');
  }

  $('li.menu-lv-item.no-megamenu.dropdown').hover(function(){
    $('body').addClass('overlay-blur');
  }, function(){
    $('body').removeClass('overlay-blur');
  });

  $('.toolbar .toolbar-item.toolbar-viewAs .toolbar-icon').click(function(){
    var col = $(this).data('col');
    $(this).parent().attr('data-layout', col);
  });
});

$(document).ready(function(){
  $('#shopify-section-template--27571450478972__1768710835349a93d5').appendTo('#productView-KlarnaClearpay');

  setTimeout(() => {
    const clearpay = document.querySelector('square-placement');
    if (clearpay?.shadowRoot) {
      clearpay.shadowRoot.querySelectorAll('*').forEach((el) => {
        el.style.fontSize = '11px';
        el.style.lineHeight = '1';
      });
      clearpay.shadowRoot.querySelectorAll('.afterpay-link').forEach((el) => {
        el.style.display = 'none';
      });
      clearpay.shadowRoot.querySelectorAll('.afterpay-logo').forEach((el) => {
        el.style.width = '72px';
      });
      clearpay.shadowRoot.querySelectorAll('svg').forEach((el) => {
        el.style.width = '72px';
        el.style.backgroundColor = '#b2fce4';
        el.style.borderRadius = '10px';
      });
      clearpay.shadowRoot.querySelector('.afterpay-paragraph').setAttribute('part', 'afterpay-paragraph');
      
      clearpay.shadowRoot.querySelector('.afterpay-main-text').insertAdjacentHTML('beforeend', 'Clearpay <button id="logo-link" class="afterpay-link" aria-label="Learn More about Clearpay - Opens a dialog" title="Learn More about Clearpay - Opens a dialog" style="font-size: 11px;"><template style="text-decoration: underline; display: inline-block; font-size: 11px;"></template></button>');
    }
  }, 1000);
});